import { render, staticRenderFns } from "./class-info.vue?vue&type=template&id=5362095d&scoped=true"
import script from "./class-info.vue?vue&type=script&lang=js"
export * from "./class-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362095d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5362095d')) {
      api.createRecord('5362095d', component.options)
    } else {
      api.reload('5362095d', component.options)
    }
    module.hot.accept("./class-info.vue?vue&type=template&id=5362095d&scoped=true", function () {
      api.rerender('5362095d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantClass/detail-pane/class-info.vue"
export default component.exports